<template>
  <v-container class="fill-height justify-center align-center">
    <v-card class="justify-center align-center" style="padding: 2.5em 5em;" max-width="600">
      <v-card-title class="justify-center" style="font-size: larger; min-width: 300px" v-if="licitacaoEncontrada">
        Não quer mais receber nossos e-mails?
      </v-card-title>
      <v-card-text v-if="licitacaoEncontrada">
        Será cancelada inscrição para o processo {{ numProcesso }} edital {{ numeroEdital }}
      </v-card-text>
      <v-card-text v-else>
        Licitação não encontrada
      </v-card-text>
      <v-card-text class="text-center" style="min-width: 300px" v-if="licitacaoEncontrada">
        <v-btn
            @click="confirmarDesinscricao"
            :disabled="botaoDisabled"
            :loading="carregando"
            :color="botaoSucesso ? 'green' : 'primary'"
            block
        >
          <template v-if="!carregando && botaoSucesso">
            <v-icon center>mdi-check</v-icon>
          </template>
          <template v-else>
            Cancelar Inscrição
          </template>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { actionTypes } from '@/commons/constants';

export default {
  name: 'DesinscricaoConfirmacao',
  data() {
    return {
      carregando: false,
      mensagem: '',
      tipoMensagem: 'success',
      isInvalidId: false,
      botaoDisabled: false,
      licitacaoId: this.$route.params.id,
      numeroEdital: undefined,
      numProcesso: undefined,
      botaoSucesso: false,
      licitacaoEncontrada: false
    };
  },
  created() {
    this.buscarLicitacaoPorId();
  },
  methods: {
    ...mapActions([actionTypes.DESINSCREVER_FORNECEDOR_EMAILS_LICITACAO, actionTypes.BUSCAR_LICITACAO_RETORNAR]),

    async confirmarDesinscricao() {
      this.carregando = true;
      this.botaoDisabled = true;

      try {
        await new Promise(resolve => setTimeout(resolve, 1000));

        await this.desinscreverFornecedorEmailsLicitacao({ licitacaoId: this.licitacaoId });
        this.mostrarNotificacaoSucesso("Você cancelou com sucesso o recebimento de notificações desta licitação.");

        this.botaoSucesso = true;
      } catch (error) {
        this.mostrarNotificacaoErro(error.response.data.message);
      } finally {
        this.carregando = false;
        if (!this.botaoSucesso) {
          this.botaoDisabled = false;
        }
      }
    },

    async buscarLicitacaoPorId() {
      try {
        const response = await this.buscarLicitacaoRetornar({ licitacaoId: this.licitacaoId });
        if (response != null) {
          this.licitacaoEncontrada = true;
          this.numProcesso = response.numProcesso;
          this.numeroEdital = response.numeroEdital;
        }
      } catch (error) {
        this.mostrarNotificacaoErro("Licitação não encontrada.");
        this.botaoDisabled = true;
      }
    },

  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}
</style>
